@if (contactStations$ | async; as contacts) {
  <p>Hier findest du passende Unterstützungsangebote für den ausgewählten Themenbereich.</p>

  <select class="select-contact-type" (change)="onSelectContactCategory($event)">
    @for(contactCategory of contactCategories(); track contactCategory.id) {
      <option [value]="contactCategory.id">{{contactCategory.title[translate.getCurrentLang()]}}</option>
    }
  </select>

  @if (displayType === 'map') {
    <app-google-map class="google-map"
      [contacts]="filteredContacts()"
      [selected]="selected()"
      (selectContact)="setSelectedContact($event)" />
  }

  <h2>Ausgewähltes Angebot</h2>
  @if (selected(); as contact) {
    <app-contact-detail [contact]="contact"></app-contact-detail>
  } @else {
    Kein Unterstützungsangebot auf der Karte ausgewählt.
  }

  @let filtered = filteredContacts();
  @if (filtered?.length > 0) {
    <h2>Andere Angebote</h2>
  }
  @for (contact of filteredContacts(); track contact.id) {

    @if (contact.id !== selected()?.id) {
      <app-contact-detail [contact]="contact"></app-contact-detail>
    }
  }
}